import { Component, EventEmitter, Input, Output } from '@angular/core';
import { data_item } from 'src/app/misc/interface/data';

@Component({
  selector: 'app-bulkview',
  templateUrl: './bulkview.component.html',
  styleUrls: ['./bulkview.component.scss']
})
export class BulkviewComponent {

  @Input() data: data_item[] = [];
  @Output() outputData = new EventEmitter<data_item[]>();

  selectedItem: any;

  filteredData: data_item[] = [];
  searchText: string = '';

  isEdited: boolean[] = [];


  ngOnInit() {
    this.filteredData = this.data;
    this.data.forEach((data_item: data_item) => {
      data_item.isChecked = false;
    })
  }


  filterData($event: any) {
    const searchText = $event.target.value.toLowerCase();
    this.data = this.filteredData.filter(item => item.name.toLowerCase().includes(searchText));
  }

  currentIndex = 0;

  updateData() {
    //console.log(this.data)
    this.isEdited[this.currentIndex] = true;
    // this.data[this.currentIndex].isChecked = true;
    // console.log(this.data[this.currentIndex]);
    this.outputData.emit(this.data);
  }

  editFlag = true;
}
